import { render } from "./UserResults.vue?vue&type=template&id=6c85a854"
import script from "./UserResults.vue?vue&type=script&lang=js"
export * from "./UserResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__